export default __webpack_public_path__ + "static/media/room7.e651989a.jpg";